import { ReactNode, useRef, useState } from 'react'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'
import { getContentStyles } from 'shared/ui/collapse/lib/getContentHeight.tsx'

import s from './styles.module.scss'

interface CollapseProps {
  title: string
  children: ReactNode
  alwaysOpen?: boolean
  count?: number
}

export const Collapse = ({
  title,
  children,
  alwaysOpen = false,
  count,
}: CollapseProps) => {
  const contentRef = useRef<HTMLDivElement>(null!)
  const [isOpen, setIsOpen] = useState(alwaysOpen)

  const toggleCollapse = () => {
    if (!alwaysOpen) setIsOpen(!isOpen)
  }

  const contentStyles = getContentStyles(alwaysOpen, isOpen, contentRef)

  return (
    <div>
      <div
        onClick={toggleCollapse}
        className={clsx(s.box, alwaysOpen && s.noCursor)}
      >
        <span className={clsx(s.title, 'semi-bold-17')}>{title}</span>

        <div className={s.icons}>
          {!!count && !isOpen && (
            <span className={clsx(s.count, 'medium-12')}>{count}</span>
          )}

          {!alwaysOpen && (
            <AppIcon
              id={AllIcons.ARROW_BOTTOM}
              className={clsx(s.icon, isOpen && s.rotate)}
            />
          )}
        </div>
      </div>

      <div
        ref={contentRef}
        style={contentStyles}
        className={clsx(s.content, isOpen && s.open)}
      >
        {children}
      </div>
    </div>
  )
}
